import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part6 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		
		scenario5_4B_s17: 'CALM - Scenario 5 - 4B - Segment 17',
		scenario5_1C_s18: 'CALM - Scenario 5 - 1C - Segment 18',
		scenario5_4C_s19: 'CALM - Scenario 5 - 4C - Segment 19',
		scenario5_4C_s20: 'CALM - Scenario 5 - 4C - Segment 20'
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part6.id;
	}

	public start() {
		const context = this;
		context.segment1Step1BenApproaches();
	}

	private segment1Step1BenApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.onDone();
	}

	private segment2Step1BenDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario5_4C_s20, () =>
			context.onDone())
	}
}